// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';
import isEmpty from 'lodash/isEmpty';

const OutfitCarouselStyle = css``;

const tabletStylesForV1 = css`
  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    .container-carousel {
      background-color: #f3f3f3;
      padding-top: 12px;
      margin-bottom: 15px;
      position: relative;
      padding-left: 27px;
      border: 1px solid;
      width: auto;

      & > div {
        margin: 10px;
      }
      & pre {
        font-size: 9px;
        font-weight: 900;
        box-shadow: rgb(88 88 88 / 50%) 0px 0px 4px 0px;
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
        border-bottom-right-radius: 2px;
        border-bottom-left-radius: 2px;
        background-color: #fff;
        padding: 10px 0px;
        margin-top: -7%;
        margin-top: -8% !important;
        margin-bottom: 0;
      }
    }
    .carousel-image {
      height: 156px;
      min-width: 125px;
    }
  }
`;

export const StyledDiv = styled.div`
  .container-carousel {
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    width: 100%;
    -ms-overflow-style: none;
    display: flex;
  }
  .container-carousel::-webkit-scrollbar {
    display: none;
  }
  .carousel-inner-container {
    display: inline-block;
    width: 177px;
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    margin-left: -15px;
    margin-right: -15px;
    .container-carousel-desktop {
      width: 100%;
    }
  }
  .heading {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    text-align: center;
  }
  .subheading {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    text-align: center;
    padding-left: 28px;
    padding-right: 28px;
  }
  .carousel-image {
    margin: 0 auto 16px;
    ${(props) =>
      props.variation3 && props.sbcDesignVariationCircle
        ? ''
        : `min-height: ${!props.variation2 && `156px`};`}
  }
  .slick-slide > div {
    padding: 0 4px;
  }
  .slick-list {
    margin: 0;
    padding-left: 20% !important;
    @media ${(props) => props.theme.mediaQuery.medium} {
      margin: 0 ${(props) => props.theme.spacing.ELEM_SPACING.MED};
      padding-left: 0 !important;
    }
  }
  .slick-arrow {
    top: calc(50% - 20px);
  }
  @media ${(props) => props.theme.mediaQuery.medium} {
    .slick-slide > div {
      padding: 0 12px;
    }
    .slick-prev,
    .slick-next {
      height: 52px;
    }
    .slick-list {
      margin: 0 38px;
    }
    .subheading {
      padding-left: 190px;
      padding-right: 190px;
    }
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    .slick-slide > div {
      padding: 0 15px;
    }
    .slick-list {
      margin: 0 60px;
    }
    .slick-slider {
      margin: 0 35px;
    }
    .heading {
      margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    }
    .subheading {
      margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXXL};
      padding-left: 290px;
    }
    .carousel-image {
      margin: 0 auto ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
      ${(props) =>
        props.variation3 && props.sbcDesignVariationCircle
          ? ''
          : `min-height: ${!props.variation2 && `238px`};`}
    }
    .container-carousel-desktop {
      .slick-list {
        margin: 0 auto;
      }
    }
  }
  ${(props) => !props.variation2 && tabletStylesForV1}
  ${(props) => (!isEmpty(props.spacingTop) ? `margin-top: ${props.spacingTop}px;` : ``)}
  ${(props) => (!isEmpty(props.spacingBottom) ? `margin-bottom: ${props.spacingBottom}px;` : ``)}
`;

export const HoverStyles = css`
  border-bottom: 2px solid ${(props) => props.theme.colors.BRAND.PRIMARY};
  font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
`;

export const StyledDivV2 = styled(StyledDiv)`
  .subheading {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    padding-left: 0px;
    border-bottom: 1px solid ${(props) => props.theme.colors.PRIMARY.LIGHT_GRAY};
    padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
    text-align: left;
    color: ${(props) => props.theme.colors.BLACK};
    line-height: ${(props) => props.theme.spacing.ELEM_SPACING.LRG_2};
  }
  .carousel-image {
    margin: 0 auto 16px;
    box-sizing: border-box;
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    height: 100%;
    box-shadow: none;
  }
  .image-circle {
    border-radius: 100%;
    background-color: ${(props) => props.theme.colors.NAVIGATION.L1_BACKGROUND};
    width: 158px;
    height: 158px;
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.XXM};
    outline: none;
    border: none;
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
  }
  .image-link > pre {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
    line-height: ${(props) => props.theme.spacing.ELEM_SPACING.MED_2};
    padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
    padding-left: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
    padding-right: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
    border: 2px solid ${(props) => props.theme.colors.WHITE};
    font-weight: ${(props) => props.theme.fonts.fontWeight.medium};
    font-size: ${(props) => props.theme.fonts.fontSize.anchor.xlarge};
    white-space: pre-wrap;
  }
  .image-link:hover > pre {
    @media ${(props) => props.theme.mediaQuery.medium} {
      ${HoverStyles}
    }
  }

  .image-circle:hover + a > pre {
    @media ${(props) => props.theme.mediaQuery.medium} {
      ${HoverStyles}
    }
  }

  .tile-container.active-category .image-link > pre {
    ${HoverStyles}
  }

  .subheading + div {
    display: block !important;
  }
  .tile-container {
    width: 100%;
    display: flex !important;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED_1};
    border: 2px solid ${(props) => props.theme.colors.WHITE};
  }
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    .image-circle {
      width: 140px;
      height: 140px;
      padding: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    }
    .subheading {
      margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
      font-weight: ${(props) => props.theme.fonts.fontWeight.semiBold};
      line-height: ${(props) => props.theme.spacing.ELEM_SPACING.MED_2};
    }

    .image-link > pre {
      font-weight: ${(props) => props.theme.fonts.fontWeight.semiBold};
      line-height: ${(props) => props.theme.spacing.ELEM_SPACING.MED_1};
    }
  }
  @media ${(props) => props.theme.mediaQuery.medium} {
    .subheading {
      padding-left: 0px;
    }
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    .subheading {
      margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXML};
      padding-right: 290px;
      padding-left: 0px;
    }
  }
  @media ${(props) => props.theme.mediaQuery.desktop} {
    .image-circle {
      width: 180px;
      height: 180px;
      padding: 6px;
    }
  }
`;

export default OutfitCarouselStyle;
